/* eslint-disable react/jsx-no-bind */

// Libraries
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

// Custom Components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import ViewEditActions from "components/DetailList/ViewEditActions";

// Pages
import Information from "pages/settingsPages/travelDesks/new-travelDesk/components/Information";

const TravelDeskDetail = ({ formData, detailPage = true, setDetailPage = false, handleEdit }) => {
  const { submitForm, resetForm } = useFormikContext();

  const handleCardTitle = () => "Travel Desk Info";

  return (
    <MDBox>
      <MDBox lineHeight={0} style={{ display: "flex", justifyContent: "space-between" }}>
        <MDTypography variant="h5" fontWeight="bold" textTransform="capitalize" mb={1}>
          {handleCardTitle()}
        </MDTypography>
        <ViewEditActions
          detailPage={detailPage}
          handleEdit={handleEdit}
          handleClose={() => {
            resetForm();
            setDetailPage(true);
          }}
          handleSave={() => {
            submitForm();
          }}
        />
      </MDBox>
      <MDBox>
        <Information formData={formData} editPage detailPage={detailPage} />
      </MDBox>
    </MDBox>
  );
};

// typechecking props for TravelDeskDetail
TravelDeskDetail.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  detailPage: PropTypes.bool,
  setDetailPage: PropTypes.func,
  handleEdit: PropTypes.func.isRequired,
};

export default TravelDeskDetail;
